
import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';

import { BaseLabel } from '../../../../styled/labels/labels';
import { COLOR_1, COLOR_17 } from '../../../../styled/variables/variables';
import dateUtil from '../../../../utils/date/date.util';

let styledBar;
let styledMarginTop;

const BarsChart = ({
  keyValuePairs,
}) => {
  keyValuePairs = keyValuePairs.slice(0, 4);
  let biggerValue = 0;
  let existValue = 0;
  
  keyValuePairs.forEach(({ value}) => {
    
    if(value >= biggerValue) biggerValue = value;

  });
  for (let index = 0; index < keyValuePairs.length; index++) {
    if(keyValuePairs[index].value ===0 && existValue === 0){
      // delete keyValuePairs[index];
    }else{
      existValue++;
    }
    
  }
 
  const diff = 4 - keyValuePairs.length;
  if(diff > 0 && diff < 4) {
    const monthNumber = dateUtil.monthToNumber({
      month: keyValuePairs[keyValuePairs.length - 1].key,
    });
    
    for (let index = 0; index < diff; index++) {
      let previousMonth = monthNumber - (index + 1);
      if(previousMonth < 1) {
        previousMonth = 12 + previousMonth;
      }

      keyValuePairs = [
        {
          key: dateUtil.numberToMonth({ number: previousMonth }),
          value: 0,
        },
        ...keyValuePairs,
      ];
    }
  }
  if (existValue === 1) {
    styledBar = '24px';
  }else if (existValue === 2) {
    styledBar = '16px';
    styledMarginTop = "8px;"
  }else if (existValue === 3) {
    styledBar = '12px';
    styledMarginTop = "4px;"
  }else {
    styledBar = '8px';
    styledMarginTop = "0px;"
  }

  return (
    <Wrapper>
      { keyValuePairs.map(({ key, value, year }) => (
        <BarWrapper key={ key }>
          <Key>{year} - { key.substring(0, 3) }</Key>
          <Bar proportion={ value / biggerValue } heighbar= {styledBar} marginTop= {styledMarginTop} />
          <Value>{ value }</Value>
        </BarWrapper>
      )) }
    </Wrapper>
  );
}

BarsChart.propTypes = {
  keyValuePairs: propTypes.array,
}

BarsChart.defaultProps = {
  keyValuePairs: [ ],
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const BarWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 20px;
`;

const Key = styled(BaseLabel)`
  color: ${ COLOR_1 };
  align-self: center;
  display:flex;
  flex-direction:row;
  font-size: 12px;
  margin-right: 7px;
  min-width: 75px !important;
  max-width: 100px;
  text-align: right;
`;

const Bar = styled.div`
  align-self: center;
  height: ${ ({ heighbar }) => heighbar };
  margin-top: ${ ({ marginTop }) => marginTop };
  flex-grow: ${ ({ proportion }) => proportion };
  width: 1px;
  background-color: ${ COLOR_1 };
  margin-right: 7px;
  border-radius: 1px;
`;

const Value = styled(Key)`
  color: ${ COLOR_17 };
  opacity: 0.8;
  text-align: left;
  font-size: 14px;
  opacity: 0.8;
`;

export default BarsChart;
